import React from 'react';

import { CallsPageContent } from './CallsPageContent';

const CallsPage = () => {
  return <CallsPageContent />;
};

export default CallsPage;
